export enum ConnectionStatus {
  ONLINE = "online",
  OFFLINE = "offline",
  NOT_GOOD = "notGood",
  RECONNECTION_REQUIRED = "reconnectionRequired",
}
